const quotes = [
    {
        text: "Yang saya suka, mereka mau dengar dulu. Hasil website-nya rapi dan stok mobil di showroom bisa kami update sendiri.",
        name: "Yusuf, Pemilik Showroom Mobil",
        place: "Jayapura",
    },
    {
        text: "Pendaftaran jamaah jadi lebih tertib. Calon jamaah langsung masuk WA admin lengkap dengan paket yang dipilih.",
        name: "Hj. Aminah, Travel Umroh",
        place: "Sentani",
    },
    {
        text: "Cafe kami akhirnya punya menu digital yang bagus. Banyak pelanggan baru bilang nemu kami dari Google.",
        name: "Dimas, Owner Cafe",
        place: "Abepura",
    },
];

export const Testimonials = () => {
    return (
        <section
            data-testid="testimonials-section"
            className="py-20 md:py-32 bg-jws-surface2"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="text-xs uppercase tracking-[0.3em] text-jws-muted mb-4">
                    (05) Suara klien
                </div>
                <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-[1] mb-16 max-w-3xl">
                    Kata mereka,
                    <br />
                    <span className="italic text-jws-primary">apa adanya</span>.
                </h2>

                <div className="space-y-16 md:space-y-24">
                    {quotes.map((q, i) => (
                        <figure
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className={`max-w-4xl ${i % 2 === 1 ? "md:ml-auto md:text-right" : ""}`}
                        >
                            <blockquote className="font-display text-xl md:text-4xl lg:text-5xl tracking-tight leading-[1.2]">
                                <span className="text-jws-primary">“</span>
                                {q.text}
                                <span className="text-jws-primary">”</span>
                            </blockquote>
                            <figcaption className="mt-8 inline-flex items-center gap-3 text-jws-muted">
                                <span className="h-px w-8 bg-jws-text" />
                                <span className="text-jws-text font-medium">
                                    {q.name}
                                </span>
                                <span>·</span>
                                <span>{q.place}</span>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};
